export const menuStyles = {
	'.MuiPaper-root': {
		width: '100%',
		maxWidth: '100%',
		height: '100%',
		borderRadius: 0,
		boxShadow: 'none',
		marginTop: '1.4rem',
		backgroundColor: 'neutrals.white',
	},
	'.MuiList-root': {
		display: 'flex',
		flexDirection: 'column',
		padding: '1.5rem 0',
		gap: '1.5rem',
		boxSizing: 'border-box',
		backgroundColor: 'white',
	},
};
